import React, { useState, useEffect } from "react";
import { isEmpty } from "@util/utils";
import EmployeesInformationsBasicEditContent from "@icoach/employees/informations/EmployeesInformationsBasicEditContent";
import EmployeesInformationsBasicReadContent from "@icoach/employees/informations/EmployeesInformationsBasicReadContent";
import { useEmployeeApi } from "@apis/useEmployeeApi";
import { Card } from "@curves/ui-base";

const EmployeesInformationsBasic = React.forwardRef((props, ref) => {
	const { employeeID: _employeeID } = props;
	const [sourceData, setSouceData] = useState({});
	const [isEdit, setEdit] = useState(false);
	const { getEmployeeInformationApi } = useEmployeeApi();
	const employeeID = Number(_employeeID);

	const getInitDataApi = async id => {
		const resp = await getEmployeeInformationApi(id);
		if (resp) {
			setSouceData(resp);
		}
	};

	const handleRefreshSourceData = () => {
		getInitDataApi(employeeID);
	};

	const handleEditClick = () => {
		setEdit(true);
	};

	const handleCancelEditClick = () => {
		setEdit(false);
	};

	useEffect(
		() => {
			getInitDataApi(employeeID);
			return () => setSouceData({});
		},
		// eslint-disable-next-line
		[]
	);

	const { resource, ...otherSourceData } = sourceData;

	return (
		<React.Fragment>
			{!isEmpty(sourceData) ? (
				<Card.CardContent className="pt-4 px-4 pb-3">
					{isEdit ? (
						<EmployeesInformationsBasicEditContent
							sourceData={otherSourceData}
							options={resource || {}}
							onCancelEditClick={handleCancelEditClick}
							onReadOnlyApi={getInitDataApi}
							// refreshData={handleRefreshSourceData}
						/>
					) : (
						<EmployeesInformationsBasicReadContent sourceData={otherSourceData} options={resource || {}} onEditClick={handleEditClick} onRefresh={handleRefreshSourceData} />
					)}
				</Card.CardContent>
			) : null}
		</React.Fragment>
	);
});

export default EmployeesInformationsBasic;
